import { create } from "zustand";

type TPayload = {
  name: string;
  description: string;
  selectedUserIdList: string[];
};

const initialState: TPayload = {
  name: "",
  description: "",
  selectedUserIdList: [],
};

interface StoreState extends TPayload {
  setName: (name: string) => void;
  setDescription: (description: string) => void;
  setSelectedUserIdList: (selectedUserIdList: string[]) => void;
  addUserId: (id: string) => void;
  removeUserId: (id: string) => void;
  reset: () => void;
}

export const useAddRoleStore = create<StoreState>((set) => ({
  ...initialState,
  setName: (name) => {
    set((state) => ({ ...state, name }));
  },
  setDescription: (description) => {
    set((state) => ({ ...state, description }));
  },
  setSelectedUserIdList: (selectedUserIdList) => {
    set((state) => ({ ...state, selectedUserIdList }));
  },
  addUserId: (id) => {
    set((state) => ({
      ...state,
      selectedUserIdList: [...state.selectedUserIdList, id],
    }));
  },
  removeUserId: (id) => {
    set((state) => ({
      ...state,
      selectedUserIdList: state.selectedUserIdList.filter(
        (userId) => userId !== id,
      ),
    }));
  },
  reset: () => set({ ...initialState }),
}));
